<template>
    <header>
        <HeaderRenderer :slot-data="categoryPage.header" :menu="categoryPage.menu ?? undefined" />
    </header>
</template>

<script setup lang="ts">
import HeaderRenderer from '@/components/prismic/HeaderRenderer.vue';
import { categoryPageStore } from '@/stores/category/CategoryPageStore';

const categoryPage = categoryPageStore();
</script>
